import type { SVGProps } from 'react';

export const DragAndDrop = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'drag and drop'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g fill={props.fill} transform="translate(9, 0)">
        <g>
          <ellipse cx="2.72222222" cy="2.8" rx="2.72222222" ry="2.8" />
          <ellipse cx="11.2777778" cy="2.8" rx="2.72222222" ry="2.8" />
        </g>
        <g transform="translate(0, 8.8)">
          <ellipse cx="2.72222222" cy="2.8" rx="2.72222222" ry="2.8" />
          <ellipse cx="11.2777778" cy="2.8" rx="2.72222222" ry="2.8" />
        </g>
        <g transform="translate(0, 17.6)">
          <ellipse cx="2.72222222" cy="2.8" rx="2.72222222" ry="2.8" />
          <ellipse cx="11.2777778" cy="2.8" rx="2.72222222" ry="2.8" />
        </g>
        <g transform="translate(0, 26.4)">
          <ellipse cx="2.72222222" cy="2.8" rx="2.72222222" ry="2.8" />
          <ellipse cx="11.2777778" cy="2.8" rx="2.72222222" ry="2.8" />
        </g>
      </g>
    </g>
  </svg>
);
